import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const OpenLinkIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_13254_19441)">
          <path
            d="M9.55575 10.6667H5.1113V12H9.55575C10.9069 12 12.0002 10.9067 12.0002 9.55556V2.44444C12.0002 1.09333 10.9069 0 9.55575 0H2.44464C1.09575 0 0.000190934 1.09333 0.000190934 2.44444V9.18667C-0.0131424 10.0467 0.673524 10.7511 1.53352 10.7644C1.96019 10.7711 2.36908 10.6022 2.66686 10.2978L7.1113 5.83111V8.44444H8.44464V4.22222C8.44464 3.85333 8.14686 3.55556 7.77797 3.55556H3.55575V4.88889H6.16908L1.72464 9.34444C1.64464 9.43778 1.50464 9.44889 1.4113 9.36889C1.35797 9.32444 1.32908 9.25556 1.33352 9.18667V2.44444C1.33352 1.83111 1.8313 1.33333 2.44464 1.33333H9.55575C10.1691 1.33333 10.6669 1.83111 10.6669 2.44444V9.55556C10.6669 10.1689 10.1691 10.6667 9.55575 10.6667Z"
            fill={props.fill ?? "#494C50"}
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
